module.exports = __webpack_public_path__ + "static/media/mon-sat_and_everyday_digital.0a99fae8.png";